import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';

require('highcharts/modules/exporting')(Highcharts);

interface IColumnChartComponentProps {
  title: string
  categories: string[]
  dataPoints: any[]
  noDataMessage?: string
  click?: any
  htmlSubtitle?: string
  name: string
  chartHeight?: number
  avannisAverage?: number
  factor?: number
}

interface IColumnChartComponentState {
  trendChartRef: any
  trendGraphOptions: any
}

export class ColumnChartComponent extends React.Component<IColumnChartComponentProps> {
  state: IColumnChartComponentState = {
    trendChartRef: undefined,
    trendGraphOptions: undefined
  }
  componentDidMount() {
    this.state.trendChartRef = React.createRef();
    if (this.props.dataPoints.length > 0) {
      this.setTrendGraphOptions();
    }
  }

  componentDidUpdate(prevProps: IColumnChartComponentProps, prevState: IColumnChartComponentState) {

    if (prevProps.dataPoints !== this.props.dataPoints) {
      this.setTrendGraphOptions();
    }
  }

  setTrendGraphOptions() {
    const { categories, click, dataPoints, noDataMessage, title, htmlSubtitle, name, chartHeight, avannisAverage, factor } = this.props;
    let columnData = [...dataPoints]
    let columnCategories = [...categories]
    if (avannisAverage && avannisAverage > 0) {
      columnData = [...columnData, {
        y: Number(avannisAverage),
        interviews: 0,
        color: '#FFAA00'
      }]
      columnCategories = [...categories, 'Avannis Avg']
    }

    let h = 245;
    if (chartHeight) {
      h = chartHeight
    }
    const suffix = this.props.factor === 100 ? '%' : '';

    const titleOptions = {
      style: {
        display: 'none'
      },
      useHTML: true,
      text: title,
      x: 0,
      y: 5,
      align: 'left'
    }
    let subtitle = {};
    if (htmlSubtitle) {
      subtitle = {
        useHTML: true,
        text: htmlSubtitle
      };
    }

    let exportingOptions: {};
    let navigationOptions: {};
    if (!categories) {
      exportingOptions = {
        buttons: {
          contextButton: {
            enabled: false
          }
        }
      };
      navigationOptions = {
        buttonOptions: {
          enabled: true
        }
      };
    } else {
      exportingOptions = {
        chartOptions: {
          title: {
            style: {
              display: 'block'
            }
          },
          subtitle: {
            align: 'center'
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        buttons: {
          contextButton: {
            symbol: 'url(images/bars.png)',
          }
        }
      };
      navigationOptions = {
        buttonOptions: {
          verticalAlign: 'top',
          y: -10
        }
      };
    }

    this.setState({
      trendGraphOptions: {
        lang: {
          noData: noDataMessage,
          useHTML: true,
        },
        chart: {
          type: 'column',
          height: h,
        },
        title: titleOptions,
        subtitle,
        xAxis: {
          categories: columnCategories,
          crosshair: true,
          minorGridLineWidth: 0,
          minorTickLength: 0
        },
        yAxis: {
          title: null,
          labels: {
            enabled: true
          },
          maxPadding: .45
        },
        tooltip: {
          borderWidth: 0,
          borderRadius: 0,
          shadow: false,
          useHTML: true,
          backgroundColor: 'rgba(255,255,255,0)',
          formatter() {
            let interviews = 'n/a';
            if (this.point.interviews) {
              interviews = this.point.interviews;
            }

            let html = '<div style="padding: 5px;">' + this.x + '<br/><span class="tooltip-interviews" style="font-size: 18px; font-weight: bold">' + this.point.y + suffix + '</span><br/>';
            if (interviews !== 'n/a') {
              html += 'Surveys: ' + interviews;
            }

            html += '</div>';
            return html;
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: '{point.y:,.0f}' + suffix,
              textShadow: false,
            }
          }
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        series: [{
          name: 'Responses',
          data: columnData,
          color: '#0077CC'
        }],
        exporting: exportingOptions,
        navigation: navigationOptions
      }
    })
  }

  render() {
    const { trendChartRef, trendGraphOptions } = this.state;
    return (
      <div>
        <section className="highcharts-component">
          {
            (trendGraphOptions && trendChartRef) &&
            <HighchartsReact
              highcharts={Highcharts}
              options={trendGraphOptions}
              allowChartUpdate={true}
              ref={trendChartRef}
              immutable={true}
            />
          }
        </section>
      </div>
    );
  }
}
